<nb-card class="card-scroll">
	<nb-card-header style="display: flex;">
		<ngx-back-navigation></ngx-back-navigation>
		<h4>
			<ngx-header-title [allowEmployee]="false">
				{{ 'CANDIDATES_PAGE.STATISTIC.STATISTICS' | translate }}
			</ngx-header-title>
		</h4>
	</nb-card-header>
	<nb-card-body>
		<nb-accordion>
			<nb-accordion-item>
				<nb-accordion-item-header
					><h6>
						{{ 'CANDIDATES_PAGE.STATISTIC.RATING' | translate }}
					</h6></nb-accordion-item-header
				>
				<nb-accordion-item-body>
					<ga-overall-rating-chart
						*ngIf="candidates"
						[candidates]="candidates"
						[employeeList]="employeeList"
					></ga-overall-rating-chart>
				</nb-accordion-item-body>
			</nb-accordion-item>

			<nb-accordion-item>
				<nb-accordion-item-header
					><h6>
						{{
							'CANDIDATES_PAGE.STATISTIC.INTERVIEWER_ASSESSMENT'
								| translate
						}}
					</h6></nb-accordion-item-header
				>
				<nb-accordion-item-body>
					<ga-interview-rating-chart
						*ngIf="candidates"
						[interviewList]="interviewList"
						[candidates]="candidates"
						[employeeList]="employeeList"
					></ga-interview-rating-chart>
				</nb-accordion-item-body>
			</nb-accordion-item>

			<nb-accordion-item>
				<nb-accordion-item-header
					><h6>
						{{
							'CANDIDATES_PAGE.STATISTIC.CRITERIONS_RATING'
								| translate
						}}
					</h6></nb-accordion-item-header
				>
				<nb-accordion-item-body>
					<ga-criterions-rating-chart
						*ngIf="candidates"
						[candidates]="candidates"
						[interviewList]="interviewList"
					></ga-criterions-rating-chart>
				</nb-accordion-item-body>
			</nb-accordion-item>

			<nb-accordion-item>
				<nb-accordion-item-header
					><h6>
						{{
							'CANDIDATES_PAGE.STATISTIC.CANDIDATE_CRITERIONS_RATING'
								| translate
						}}
					</h6></nb-accordion-item-header
				>
				<nb-accordion-item-body>
					<ga-average-criterions-rating-chart
						*ngIf="candidates"
						[candidates]="candidates"
						[interviewList]="interviewList"
					></ga-average-criterions-rating-chart>
				</nb-accordion-item-body>
			</nb-accordion-item>
		</nb-accordion>
	</nb-card-body>
</nb-card>
